import styled from 'styled-components';

export const OverviewTile = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 188px;
	width: 100%;
	padding: 16px;
	border-radius: 6px;
	border: 1px solid #dee2e6;
`;

export const Title = styled.div`
    color: #101828;
    font-size: 17.5px;
    font-weight: 400;
    line-height: 21px;
	text-align: left;
`;

export const HeroText = styled.div`
    color: #495057;
    font-size: 49px;
    font-weight: 400;
    line-height: 56px;
	text-align: left;
    margin-top: 24px;
`;
